import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportertigacab() {



  const cardData = {


  keyword: "Pune to Mumbai Airport Ertiga Cab",

  headingDescription: "Trustline Cab provides reliable Pune to Mumbai Airport Ertiga cab services with spacious, comfortable, and affordable transportation for domestic and international airport transfers. Whether you are traveling for business, corporate meetings, family vacations, group travel, or carrying extra luggage, our Maruti Ertiga offers a smooth and comfortable journey from Pune to Mumbai Airport. Our experienced chauffeurs ensure timely pickups, flight-friendly scheduling, safe driving, and hassle-free airport transfers. With transparent pricing, doorstep pickup, easy online booking, well-maintained Ertiga vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mumbai Airport Ertiga taxi services.",

 topPlaces: [
  {
    title: "Pune to Mumbai Airport",
    description: "Travel comfortably from Pune to Mumbai Airport with a reliable Ertiga cab service, offering convenient door-to-door transportation for airport transfers."
  },
  {
    title: "Pune Airport Pickup",
    description: "Book an Ertiga cab from your home, hotel, or any location in Pune for a comfortable and hassle-free journey to Mumbai Airport."
  },
  {
    title: "Mumbai Airport Drop",
    description: "Enjoy a smooth and timely drop-off at Mumbai Airport with professional drivers and a comfortable Ertiga suitable for airport travel."
  },
  {
    title: "Pune to Mumbai Airport Cab",
    description: "A convenient outstation cab option for travelers looking for a comfortable and dependable journey between Pune and Mumbai Airport."
  },
  {
    title: "Ertiga Airport Transfer",
    description: "Ertiga cabs offer spacious seating and ample luggage capacity, making them a practical choice for families and groups traveling to Mumbai Airport."
  },
  {
    title: "Pune to Mumbai Airport One Way Cab",
    description: "Choose a one-way Ertiga cab from Pune to Mumbai Airport for a convenient airport transfer without the need to book a return journey."
  },
  {
    title: "Pune to Mumbai Airport Round Trip",
    description: "Round-trip Ertiga cab service is available for passengers who need comfortable transportation from Pune to Mumbai Airport and back."
  }
],






"services": [
  {
    "name": "Pune to Mumbai Airport Ertiga Taxi",
    "description": "Book Pune to Mumbai Airport Ertiga Taxi for comfortable airport transfers with spacious 6-seater AC vehicles, professional chauffeurs, doorstep pickup, fixed pricing, luggage space, and reliable service for families, corporate travelers, and group travel."
  },
  {
    "name": "Pune to Mumbai Airport Ertiga Cab Service",
    "description": "Choose Pune to Mumbai Airport Ertiga Cab Service with experienced drivers, clean AC Ertiga vehicles, transparent fares, flexible pickup timings, and safe intercity travel for airport transfers, business trips, and family journeys."
  },
  {
    "name": "Pune to Mumbai Airport Ertiga Booking",
    "description": "Complete your Pune to Mumbai Airport Ertiga Booking with instant confirmation, affordable pricing, professional chauffeurs, and comfortable 6-seater vehicles for hassle-free airport transportation."
  },
  {
    "name": "Book Ertiga Cab Pune to Mumbai Airport",
    "description": "Book Ertiga Cab Pune to Mumbai Airport anytime for reliable airport transfers with spacious seating, ample luggage capacity, fixed fares, and experienced drivers ensuring a smooth travel experience."
  },
  {
    "name": "Online Pune to Mumbai Airport Ertiga Cab",
    "description": "Reserve your Online Pune to Mumbai Airport Ertiga Cab with quick confirmation, secure booking, transparent pricing, and chauffeur-driven AC vehicles available for airport pickup and drop."
  },
  {
    "name": "Pune to Mumbai Airport Ertiga Car Rental",
    "description": "Choose Pune to Mumbai Airport Ertiga Car Rental for family travel, airport transfers, corporate trips, and comfortable intercity journeys with premium chauffeur-driven vehicles."
  },
  {
    "name": "Pune to Mumbai Airport 6 Seater Cab",
    "description": "Book Pune to Mumbai Airport 6 Seater Cab with spacious Ertiga vehicles, comfortable seating, luggage space, affordable pricing, and professional drivers for family and group travel."
  },
  {
    "name": "Pune to Mumbai Airport Family Cab",
    "description": "Choose Pune to Mumbai Airport Family Cab with clean AC vehicles, comfortable seating, experienced chauffeurs, and safe travel for families, children, and senior citizens."
  },
  {
    "name": "Pune to Mumbai Airport SUV Cab",
    "description": "Book Pune to Mumbai Airport SUV Cab with Ertiga and other spacious SUVs offering premium comfort, reliable airport transfers, transparent pricing, and professional chauffeur service."
  },
  {
    "name": "Pune to Mumbai Airport Private Cab",
    "description": "Hire Pune to Mumbai Airport Private Cab for exclusive travel with flexible pickup, experienced drivers, AC vehicles, and comfortable airport transportation."
  },
  {
    "name": "Pune to Mumbai Airport Premium Cab",
    "description": "Travel with Pune to Mumbai Airport Premium Cab featuring well-maintained vehicles, professional chauffeurs, fixed fares, comfortable seating, and dependable airport transfer services."
  },
  {
    "name": "Pune to Mumbai Airport Cab Service",
    "description": "Our Pune to Mumbai Airport Cab Service provides one-way airport transfers with punctual pickup, clean AC vehicles, experienced drivers, transparent pricing, and 24x7 customer support."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Service",
    "description": "Book Pune to Mumbai Airport Taxi Service for affordable airport transportation with reliable drivers, comfortable vehicles, secure travel, and timely drop service."
  },
  {
    "name": "Pune to Mumbai Airport AC Ertiga Cab",
    "description": "Choose Pune to Mumbai Airport AC Ertiga Cab for spacious, air-conditioned travel with professional chauffeurs, fixed pricing, and comfortable airport connectivity."
  },
  {
    "name": "Pune to Mumbai Airport Drop Cab",
    "description": "Book Pune to Mumbai Airport Drop Cab for direct airport drop with experienced drivers, clean vehicles, affordable fares, and reliable intercity transportation."
  },
  {
    "name": "Pune to Mumbai Airport Travel Cab",
    "description": "Reserve Pune to Mumbai Airport Travel Cab for business travel, family vacations, corporate airport transfers, and holiday trips with premium chauffeur-driven vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Intercity Cab",
    "description": "Choose Pune to Mumbai Airport Intercity Cab for safe long-distance travel with professional drivers, comfortable AC vehicles, transparent pricing, and dependable service."
  },
  {
    "name": "Pune to Mumbai Airport Ertiga Hire",
    "description": "Hire Pune to Mumbai Airport Ertiga with spacious seating, professional chauffeurs, fixed fares, comfortable AC interiors, and reliable airport transfer service for families and groups."
  }
],

"tableData": [
  ["Pune to Mumbai Airport Ertiga Taxi", "Pune to Mumbai Airport Ertiga Cab Service"],
  ["Pune to Mumbai Airport Ertiga Booking", "Book Ertiga Cab Pune to Mumbai Airport"],
  ["Online Pune to Mumbai Airport Ertiga Cab", "Pune to Mumbai Airport Ertiga Car Rental"],
  ["Pune to Mumbai Airport 6 Seater Cab", "Pune to Mumbai Airport Family Cab"],
  ["Pune to Mumbai Airport SUV Cab", "Pune to Mumbai Airport Private Cab"],
  ["Pune to Mumbai Airport Premium Cab", "Pune to Mumbai Airport Cab Service"],
  ["Pune to Mumbai Airport Taxi Service", "Pune to Mumbai Airport AC Ertiga Cab"],
  ["Pune to Mumbai Airport Drop Cab", "Pune to Mumbai Airport Travel Cab"],
  ["Pune to Mumbai Airport Intercity Cab", "Pune to Mumbai Airport Ertiga Hire"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Pune to Mumbai Airport Ertiga Cab",
    WhyChoosedescription: "Trustline Travels offers reliable Ertiga cab services from Pune to Mumbai Airport with spacious seating, smooth rides, and timely airport transfers."
  },
  {
    WhyChooseheading: "Ideal Vehicle for Families & Small Groups",
    WhyChoosedescription: "The Maruti Ertiga is perfect for families, friends, and business travelers looking for extra seating and luggage space during airport travel."
  },
  {
    WhyChooseheading: "Punctual Airport Transfer Service",
    WhyChoosedescription: "Our experienced chauffeurs ensure timely departures and arrivals, helping you reach Mumbai Airport without any last-minute stress."
  },
  {
    WhyChooseheading: "Pickup from Any Location in Pune",
    WhyChoosedescription: "We provide doorstep pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major areas across Pune."
  },
  {
    WhyChooseheading: "Affordable Ertiga Cab Fare",
    WhyChoosedescription: "Enjoy competitive pricing with transparent fare details and no hidden charges for your Pune to Mumbai Airport Ertiga booking."
  },
  {
    WhyChooseheading: "Professional & Courteous Drivers",
    WhyChoosedescription: "Our trained drivers are familiar with airport routes and provide a safe, comfortable, and hassle-free travel experience."
  },
  {
    WhyChooseheading: "Suitable for Domestic & International Flights",
    WhyChoosedescription: "Whether you're flying from Terminal 1 or Terminal 2, our Ertiga cab service ensures reliable airport connectivity at any time."
  },
  {
    WhyChooseheading: "Instant Booking & 24/7 Support",
    WhyChoosedescription: "Book your Pune to Mumbai Airport Ertiga cab anytime with quick confirmation and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Mumbai Airport Ertiga cab service?",
    answer: "Yes, Trustline Travels offers comfortable Ertiga cab services from Pune to Mumbai Airport for individuals, families, and corporate travelers."
  },
  {
    question: "Can I book an Ertiga cab for Mumbai Airport Terminal 1 and Terminal 2?",
    answer: "Yes, our Ertiga airport transfer service is available for both Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Why choose an Ertiga for airport travel?",
    answer: "The Ertiga offers spacious seating, excellent luggage capacity, and comfortable interiors, making it a popular choice for airport transfers."
  },
  {
    question: "Do you provide pickup from Pune Airport and Pune Railway Station?",
    answer: "Yes, we offer pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential locations across Pune."
  },
  {
    question: "Can I book a one-way Ertiga cab to Mumbai Airport?",
    answer: "Yes, affordable one-way Ertiga airport transfers are available with flexible pickup timings."
  },
  {
    question: "Are toll and airport parking charges included in the fare?",
    answer: "Toll charges, airport parking fees, and applicable taxes are generally charged separately unless specifically included in your booking quotation."
  },
  {
    question: "Is the Ertiga airport cab service available 24/7?",
    answer: "Yes, our Pune to Mumbai Airport Ertiga cab service is available round the clock for all flight schedules."
  },
  {
    question: "Should I reserve my Ertiga cab before my travel date?",
    answer: "Yes, advance booking is recommended to ensure availability, especially during weekends, holidays, and peak travel periods."
  },
  {
    question: "Is the Ertiga suitable for family airport transfers?",
    answer: "Yes, the Ertiga is an excellent option for families, small groups, and passengers carrying multiple bags."
  },
  {
    question: "How can I book a Pune to Mumbai Airport Ertiga Cab with Trustline Travels?",
    answer: "Simply share your pickup address, flight details, travel date, passenger count, and preferred pickup time to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket More",
    feedback: "The Ertiga was the perfect choice for our airport transfer with plenty of luggage space and comfortable seating. Trustline Travels ensured timely pickup and a smooth drive to Mumbai Airport.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Bhavna Kapoor",
    feedback: "Everything was handled professionally, from booking confirmation to airport drop. The clean Ertiga, courteous chauffeur, and punctual service made the journey pleasant and completely worry-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Ertiga Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-airport-ertiga-cab.webp",
  "description": "Book Pune to Mumbai Airport Ertiga cab service with Trustline Travels for spacious and comfortable airport transfers. Get reliable Ertiga taxi services from Pune to Mumbai Airport with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6538"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹14/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-airport-ertiga-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Airport Ertiga Cab | Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Airport Ertiga cab with Trustline Travels for comfortable and affordable airport travel. Get spacious Ertiga taxi services with professional drivers available 24x7 for Pune Mumbai airport transfers."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Airport Ertiga Taxi, Pune to Mumbai Airport Ertiga Cab Service, Pune to Mumbai Airport Ertiga Booking, Book Ertiga Cab Pune to Mumbai, Pune Mumbai Airport Ertiga Cab, Pune Airport to Mumbai Airport Ertiga Taxi, Pune to Mumbai Airport 6 Seater Cab, Pune Mumbai airport family cab, Pune Mumbai Ertiga rental service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportertigacab;